import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class SeguridadService {

  constructor(private config: ConfigService, private http: HttpClient) {

  }

  getSha256 = (value: String) => {
    const url = this.config.urlService + "api/Seguridad/" + value;
    const requestOptions = new Object({
      headers: new HttpHeaders().append('responseType', `text/plain; charset=utf-8`)
    });
    return this.http.get(url);
  }
}
